







import { Component, Prop, Vue } from 'vue-property-decorator';
import { BlockDto } from '@/api';
import { blockMapping } from '@/views/cms/BlockMapping';
import UnknownBlock from '@/views/cms/UnknownBlock.vue';

@Component
export default class BlocksDispatcher extends Vue {
  @Prop({required: true})
  public readonly blocks!: BlockDto[];

  public created() {
    // We need to register Vue components *before we ourselves are mounted*, so do that here
    // ref: https://stackoverflow.com/a/60081878/1117552
    if (!this.$options.components) {
      this.$options.components = {};
    }
    const blockTypes = this.blocks.map((block) => block.type);
    for (const blockType of blockTypes) {
      if (this.$options.components[blockType]) {
        continue;
      }
      const importFunction = blockMapping.get(blockType);
      if (importFunction) {
        const exports = importFunction();
        this.$options.components[blockType] = exports.default;
      } else {
        this.$options.components[blockType] = UnknownBlock;
      }
    }
  }
}
